// Variables para modificar el tamaño del mapa y la card 

export const MAP_CELL_SIZE = 20; // Define el tamaño de la celda
export const MAP_FRAME_HEIGHT = 190; // Define el tamaño del contenedor del mapa